import {
  GET_ALL_CUSTOMERS,
  GET_ALL_CUSTOMERS_ERR,
  CHANGE_STATUS,
  CHANGE_STATUS_ERR,
  GET_ALL_LOGS
} from "constants/ActionTypes";

var initialState = {
  loader: new Date(),
  customers: [],
  logs: [],
  getCustomerStatus: "not done",
  getLogsStatus: "not done",
  changeStatus: "not done"
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_CUSTOMERS:
      return {
        ...state,
        loader: new Date(),
        customers: action.payload,
        getCustomerStatus: "done"
      };
    case GET_ALL_LOGS:
      console.log("In Reducer Logs", action.payload);
      return {
        ...state,
        loader: new Date(),
        logs: action.payload,
        getLogsStatus: "done"
      };
    case GET_ALL_CUSTOMERS_ERR:
      return {
        ...state,
        loader: new Date(),
        getCustomerStatus: "error"
      };
    case CHANGE_STATUS:
      return {
        ...state,
        loader: new Date(),
        changeStatus: "done"
      };
    case GET_ALL_CUSTOMERS_ERR:
      return {
        ...state,
        loader: new Date(),
        changeStatus: "error"
      };

    default:
      return state;
  }
}
